import React from "react";
import '../App.css'
import a1 from "../assets/a1.webp";
import a2 from "../assets/a2.webp";
import a3 from "../assets/a3.webp";
import a4 from "../assets/a4.webp";

const logos = [a4, a1, a2, a3];

export default function AuthorisedSection() {
  const trackItems = [...logos, ...logos];

  return (
    <section className="relative bg-gradient-to-br from-gray-50 via-white to-amber-50/30 overflow-hidden py-16 px-6 md:px-12 lg:px-16">
      {/* background gradient blobs */}
      <div className="absolute inset-0 opacity-6 pointer-events-none">
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(circle at 10% 20%, rgba(233,30,99,0.03), transparent 20%), radial-gradient(circle at 80% 80%, rgba(255,193,7,0.03), transparent 25%)",
          }}
        />
      </div>
      <div className="absolute top-20 left-20 w-32 h-32 bg-gradient-to-br from-[#E91E63]/10 to-[#D32F2F]/10 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-20 right-20 w-40 h-40 bg-gradient-to-br from-amber-400/10 to-orange-400/10 rounded-full blur-3xl pointer-events-none" />

      <div className="container mx-auto relative z-10">
        {/* Header */}
        <div className="text-center">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-[#E0F7FA] to-[#E0F2F1] backdrop-blur-sm px-6 py-3 rounded-full shadow-lg border border-[#00838F]/20 mb-8">
            <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 text-[#00838F]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
            </svg>
            <span className="text-sm font-semibold text-[#00838F]">Trusted &amp; Verified</span>
          </div>
          <h2 className="sm:text-4xl text-[22px] md:text-5xl lg:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-gray-900 via-[#E91E63] to-[#D32F2F] leading-tight mb-6">
            Authorised and Licensed by
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-[#E91E63] to-[#D32F2F] mx-auto rounded-full mb-4" />
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            Officially recognized and certified by India's leading tourism authorities for{" "}
            <span className="font-semibold text-[#E91E63]">authentic experiences</span>.
          </p>
        </div>

        {/* Logo Marquee */}
        <div className="relative mt-16">
          <div className="relative overflow-hidden py-8">
            <div className="absolute inset-y-0 left-[-10px] w-20 bg-gradient-to-r from-gray-50 to-transparent z-10 pointer-events-none" />
            <div className="absolute inset-y-0 right-0 w-20 bg-gradient-to-l from-gray-50 to-transparent z-10 pointer-events-none" />
            <div className="marquee-wrapper">
              <div className="marquee-track">
                {trackItems.map((src, idx) => (
                  <div key={`${idx}`} className="flex-shrink-0 sm:w-56 md:w-64 lg:w-72 xl:w-80 px-3">
                    <div className="relative p-4 bg-white rounded-2xl shadow-lg border border-gray-100 group">
                      <img alt={`logo-${idx}`} loading="lazy" className="object-contain h-[150px] w-full" src={src} />
                      <div className="absolute -top-2 -right-2 bg-gradient-to-r from-[#E91E63] to-[#D32F2F] text-white text-xs font-bold px-2 py-1 rounded-full opacity-0 group-hover:opacity-100 shadow-lg">
                        Verified
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Features */}
        <div className="mt-12 flex flex-wrap items-center justify-center gap-6">
          <span className="flex items-center gap-2 text-gray-600"><svg className="w-5 h-5 text-emerald-500" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21.8 10A10 10 0 1 1 17 3.3"/><path d="m9 11 3 3L22 4"/></svg> Government Approved</span>
          <span className="flex items-center gap-2 text-gray-600"><svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 13c0 5-3.5 7.5-7.66 8.95"/><path d="M9 11l3 3L22 4"/></svg> Licensed Operator</span>
          <span className="flex items-center gap-2 text-gray-600"><svg className="w-5 h-5 text-amber-500" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="8" r="6"/><path d="m15.5 12.9 1.5 8.5-3.58-2.68-3.58 2.68 1.5-8.5"/></svg> Certified Excellence</span>
        </div>
      </div>

      {/* Marquee Animation */}
      <style>{`
        .marquee-wrapper { overflow: hidden; }
        .marquee-track { display: flex; width: max-content; animation: marquee 18s linear infinite; }
        .marquee-track:hover { animation-play-state: paused; }
        @keyframes marquee { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
        @media (max-width: 640px) { .marquee-track { animation-duration: 12s; } }
        @media (max-width: 480px) { .marquee-track { animation-duration: 10s; } }
      `}</style>
    </section>
  );
}
